function setupToggleForMobile() {
  const isMobile = window.innerWidth <= 768;

  document.querySelectorAll('.event_bloc, .listing-filters').forEach((bloc) => {
    const button = bloc.querySelector('.toggleButton');
    const container = bloc.querySelector('.toggleContainer');

    if (!button || !container) return;

    const newButton = button.cloneNode(true);
    button.replaceWith(newButton);

    if (isMobile) {
      container.classList.add('hidden');
      newButton.addEventListener('click', () => {
        container.classList.toggle('hidden');
        newButton.classList.toggle('toggleButton-open');
      });
    } else {
      container.classList.remove('hidden');
    }
  });
}

window.addEventListener('DOMContentLoaded', setupToggleForMobile);
window.addEventListener('resize', setupToggleForMobile);
